<template>
  <div ref="toolBox" class="tool-box df both-side">
    <div></div>
    <a-space>
      <a-button @click="print">打印</a-button>
      <a-button @click="closeIframe" type="danger">关闭</a-button>
    </a-space>
  </div>

  <div ref="doprintcodepage" class="instruction-print">
    <div class="print-area">
      <div class="df both-side header">
        <div>表单编号: {{ printData.formNumber }}</div>
        <div>版本版次: {{ printData.edition }}</div>
      </div>

      <table border="1" class="instruction-print-table">
        <tr>
          <td colspan="8" class="title">生产指令单</td>
        </tr>

        <tr>
          <td class="sub-title">生产日期：</td>
          <td colspan="3">{{ printData.produceDate }}</td>

          <td colspan="3" class="sub-title">编制/日期</td>
          <td>{{ printData.writer }}  {{ printData.writeDate }}</td>
        </tr>

        <tr>
          <td></td>
          <td colspan="3"></td>

          <td colspan="3" class="sub-title">审核/日期</td>
          <td>{{ printData.reviewer }}  {{ printData.reviewDate }}</td>
        </tr>

        <tr>
          <td class="sub-title">完成时间</td>
          <td colspan="3">{{ printData.finishDate }}</td>

          <td colspan="3" class="sub-title">批准/日期</td>
          <td>{{ printData.approver }}  {{ printData.approveDate }}</td>
        </tr>

        <tr class="sub-title">
          <td>生产批号</td>
          <td>产品名称</td>
          <td>型号规格</td>
          <td>单位</td>
          <td>数量</td>
          <td>用途</td>
          <td>产品编号</td>
          <td>下级名称/编号</td>
        </tr>

        <tr>
          <td>{{ printData.batchNumber }}</td>
          <td>{{ getProcessName(printData.productName) }}</td>
          <td>{{ printData.modelSpecifications }}</td>
          <td>{{ printData.unit }}</td>
          <td>{{ printData.number }}</td>

          <td>
            <div class="applications">
              {{ printData.applications }}
            </div>
          </td>
          
          <td style="padding: 0" class="remove-border">
            <template v-for="item in prodcutNumberList" :key="item.snNumber">
              <div
                class="sn-border"
                :style="{
                  height: `${SNHEIGHT * item.subordinateCount}px`,
                  lineHeight: `${SNHEIGHT * item.subordinateCount}px`,
                }"
              >
                {{ item.snNumber }}
              </div>
            </template>
          </td>

          <td style="padding: 0" class="remove-border">
            <div
              v-for="subordinate in subordinateList"
              :style="{
                height: `${SNHEIGHT}px`,
                lineHeight: `${SNHEIGHT}px`,
              }"
              :key="subordinate"
              class="sub-sn-border"
            >
              {{ subordinate }}
            </div>
          </td>
        </tr>
      </table>

      <div>
        <a-space>
          仓库:
          <a-checkbox>发料</a-checkbox>
          发料人:
          <div class="check-underline">
            {{ printData.goodsIssue }}
          </div>
          完成时间:
          <div class="check-underline">
            {{ printData.goodsIssueDate }}
          </div>
        </a-space>
      </div>

      <div class="mt20">
        <a-space>
          生产:
          <a-checkbox>领料</a-checkbox>
          领料人:
          <div class="check-underline">
            {{ printData.picker }}
          </div>
          完成时间:
          <div class="check-underline">
            {{ printData.pickDate }}
          </div>
        </a-space>
      </div>

      <div class="mt20">
        <a-space>
          生产:
          <a-checkbox>装配</a-checkbox>
          核对人:
          <div class="check-underline">
            {{ printData.checked }}
          </div>
          完成时间:
          <div class="check-underline">
            {{ printData.checkedDate }}
          </div>
        </a-space>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted, reactive, ref } from "vue";
import { getProcessName } from "@/views/productDaily/serve/option";

export default defineComponent({
  setup() {
    // 渲染列表dom
    const doprintcodepage = ref();
    // 工具栏
    const toolBox = ref();

    // 打印前的操作
    const beforePrint = () => {
      doprintcodepage.value.style.overflow = "initial";
      toolBox.value.style.display = "none";
    };

    // 打印后的操作
    const afterPrint = () => {
      doprintcodepage.value.style.overflow = "scroll";
      toolBox.value.style.display = "flex";
    };

    window.onbeforeprint = beforePrint;
    window.onafterprint = afterPrint;

    const closeIframe = () => {
      localStorage.removeItem("print-instruction-data");
      window.parent.postMessage("closeIframe", "*");
    };

    const printData = ref({});

    // 编号的高度
    const SNHEIGHT = 30;

    // 产品编号
    const prodcutNumberList = reactive([]);
    // 下级编号
    const subordinateList = reactive([]);

    const setProductNumber = () => {
      prodcutNumberList.length = 0;
      subordinateList.length = 0;
      if (printData.value && printData.value.pqcList) {
        printData.value.pqcList.forEach((item) => {
          // 渲染产品编号
          const snInfo = {
            snNumber: item.snNumber,
            subordinateCount: 1,
          };
          // 下级编号处理
          if (item.children && item.children.length > 0) {
            item.children.forEach((subordinate) => {
              subordinateList.push(subordinate.snNumber);
            });
            snInfo.subordinateCount = item.children.length;
          } else {
            subordinateList.push("");
          }
          prodcutNumberList.push(snInfo);
        });
      }
    };

    const getData = () => {
      const data = localStorage.getItem("print-instruction-data");
      if (data) {
        printData.value = JSON.parse(data);
        setProductNumber();
      }
    };

    const print = () => {
      window.print();
    };

    onMounted(() => {
      document.body.style.height = "95vh";
      document.body.style.width = "1200px";
      getData();
    });

    return {
      toolBox,
      SNHEIGHT,
      printData,
      doprintcodepage,
      subordinateList,
      prodcutNumberList,
      print,
      getProcessName,
      closeIframe,
    };
  },
});
</script>

<style lang = "less" scoped>
@page {
  size: landscape;
}

@media print {
  @page {
    margin: 0;
  }
  body {
    margin: 0;
    padding: 0;
  }

  html {
    margin: 0;
    padding: 0;
  }
}

.instruction-print {
  font-size: 16px;
  height: 94vh;
  overflow: scroll;
}

.tool-box {
  padding: 10px;
}

.header {
  border-bottom: 1px solid #000;
  margin: 20px 0;
}

.check-underline {
  width: 120px;
  border-bottom: 1px solid #000;
  margin-right: 10px;
  text-align: center;
}

.print-area {
  width: 1146px;
  padding: 0 40px;
}

.instruction-print-table {
  margin-bottom: 20px;
  td {
    padding: 10px 16px;
    text-align: center;
  }
  .title {
    font-size: 18px;
    font-weight: bold;
  }
  .sub-title {
    font-size: 16px;
    font-weight: bold;
  }
  .applications {
    width: 120px;
  }

  .sn-border {
    width: 190px;
    text-align: center;
    border-bottom: 1px solid #000;
  }

  .sub-sn-border {
    width: 245px;
    text-align: center;
    border-bottom: 1px solid #000;
  }
}
.remove-border :last-child {
  border-bottom: none;
}
</style>
